<template>
  <div>
    <Table border ref="tableSelection" :columns="columns4" :data="data1"></Table>
    <!--     <Button @click="handleSelectAll(true)">Set all selected</Button>
    <Button @click="handleSelectAll(false)">Cancel all selected</Button> -->
  </div>
</template>
<script>
//文件名去除带有<hit>的命中标签
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'MultiScreenMenu',
  data() {
    return {
      columns4: [{
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '文件名',
          key: 'filename',
          render:(h,params) =>{
            const row = params.row;
            const text = row.filename.replace("<hit>","").replace("</hit>","");
            return h('a', {
                domProps:{
                   innerHTML:``+text+``
                },
                
              }, text);
          }
        }
      ],
      data1: []
    }
  },
  computed: {
    ...mapGetters(['sta'])
  },
  methods: {
    ...mapActions(['handleSetUserLogout']),
    onSelect(arg) {

    },
    handleSelectAll(status) {
      this.$refs.tableSelection.selectAll(status);
    },
    showDeleted(sliders) {
      // var list=this.getSelected()
      // console.log(list)
      // var list=sliders
      // console.log(list)
    },
    getSelected() {
      return this.$refs.tableSelection.getSelection()
    },
    bindData(sliders) {
      //console.log(sliders)
      var mockTable=this.createTable(sliders)
      this.data1 = mockTable
    },
    mounted(){
      //this.handleSelectAll(true)

    },
    createTable(sliders){
      let da = []
      let items=sliders
      for (var i = 0; i < items.length; i++) {
        da.push({
          fileid: items[i].fileid,
          filename: items[i].filename.replace("<hit>","").replace("</hit>",""),
          index:items[i].index,
          key:items[i].key,
          _checked: true,
        })
      }
      return da
    },

  }
}

</script>
<style>
</style>
